<template>
    <div class="tablelist">
        <!--Se maneja el Header del componente de las tablas-->
        <div class="tableHeader">
            <!--Se maneja el botón para la creación de nuevos registros en Generic-Form-->
            <div @click="openModalInsertData('create', null)" class="tableHeaderButton">
                <button class="button-create-dea">Nuevo</button>
            </div>
            <!--Se maneja la paginación de la tabla-->
            <div class="tableHeaderPager">
                <va-select v-model="perPage" :label="$t('tables.perPage')" :options="perPageOptions" />
            </div>
        </div>
        <!--Se maneja la data de la tabla, y se imprime usando vuestic ui-->
        <va-data-table :fields="HeadTable" :data="transformedTableData" :per-page="parseInt(perPage)" no-data-label="No hay datos">
            <!--Se maneja la lógica para la columna det_Form, para agregar un icono en lugar del texto original-->
            <template slot="det_Form"  slot-scope="props">
                <div div v-for="item of fields[fields.length - 1].actionRef" :key="item.id_Generic_Form">
                    <template v-if="item.action === 'openDet'">
                        <a @click="openModalDetails(props.rowData)">
                            <img class="imgdata ma-0" :id="props.rowData.id_Generic_Form" src="../../assets/images/detail.png" alt="openDet" title="OpenDet" width="30" />
                        </a>
                    </template>
                </div>
            </template>
            <!--Se maneja la lógica para la columna de edición de registros-->
            <template slot="actionsFirst" slot-scope="props">
                <div v-for="item of fields[fields.length - 1].actionRef" :key="item.id_Generic_Form" class="images_container">
                    <template v-if="item.action === 'edit'">
                        <a @click="openModalInsertData('edit',props.rowData)">
                            <img class="imgdata ma-0" :id="props.rowData.id_Generic_Form" src="../../assets/images/edit.png" alt="Editar" title="Editar" width="25"/>
                        </a>
                    </template>
                </div>
            </template>
            <!--Se maneja la lógica para la columna de manejo de las preguntas, ligadas a cada registro-->
            <template slot="actions" slot-scope="props">
                <div v-for="item of fields[fields.length - 1].actionRef" :key="item.id_Generic_Form" class="images_container">
                    <template v-if="item.action === 'question'">
                        <a v-if="checkIfIdExists(props.rowData.id_Generic_Form)" @click="openModalInsertData('questionTwo',props.rowData)">
                          <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-question-mark imgdata ma-0" width="35" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#00b341" fill="none" stroke-linecap="round" stroke-linejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                            <path d="M8 8a3.5 3 0 0 1 3.5 -3h1a3.5 3 0 0 1 3.5 3a3 3 0 0 1 -2 3a3 4 0 0 0 -2 4" />
                            <path d="M12 19l0 .01" />
                          </svg>
                        </a>
                        <a v-else @click="openModalInsertData('question',props.rowData)">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-question-mark imgdata ma-0" width="35" height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#ff9300" fill="none" stroke-linecap="round" stroke-linejoin="round">
                              <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                              <path d="M8 8a3.5 3 0 0 1 3.5 -3h1a3.5 3 0 0 1 3.5 3a3 3 0 0 1 -2 3a3 4 0 0 0 -2 4" />
                              <path d="M12 19l0 .01" />
                            </svg>
                        </a>
                    </template>
                </div>
            </template>
        </va-data-table>
    </div>
</template>

<script>
export default {
  props: {
    InfoView: Array,
    HeadTable: Array,
    GenericFormQuestions: Array
  },
  data () {
    return {
      perPage: '20',
      perPageOptions: ['5', '10', '15', '20'],
      modalData: null,
      tableData: this.InfoView
    }
  },
  computed: {
    //Retorna la data de la variable que contiene los títulos columnas
    fields () {
      return this.HeadTable
    },
    //Retorna la data que se imprime en la tabla, en lower case
    transformedTableData () {
      return this.InfoView.map(item => {
        const transformedItem = {}
        for (const key in item) {
          if (Object.hasOwnProperty.call(item, key)) {
            transformedItem[key] = typeof item[key] === 'string' ? item[key].toLowerCase() : item[key]
          }
        }
        return transformedItem
      })
    },
    questionGenericValidation(){
      return this.GenericFormQuestions
    }
  },
  methods: {
    checkIfIdExists(id) {
      return this.GenericFormQuestions.some(item => item.id_Generic_Form === id) ? true : false;
    },
    //Envía un emit al componente principal, para abrir el modal de det_Form
    openModalDetails (bodyDetail) {
      this.$emit('OpenModalDetails', bodyDetail)
    },
    //Envía un emit al componente principal, para abrir el modal que crea y edita registros
    openModalInsertData(action, objectData){
      this.$emit('OpenModalInsertData', action, objectData)  
    },
    //Método que es invocado desde el componente principal, para actualizar la data cuando se hace un cambio en base de datos
    updateTableData(newData) {
      this.tableData = newData;
    },
  },
}
</script>

<style>

.tablelist .tableHeader{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 2rem;
    margin-top: 1.5rem;
}

.tablelist .tableHeader .tableHeaderPager{
    width: 150px;
}

.tablelist .va-select__label {
    color: #222;
}

.va-data-table__vuetable th {
    font-weight: 900;
    text-align: center; /* Alineación horizontal centrada */
}

.va-select__option--selected {
    color: #222;
}

.tablelist .va-button--small .va-button__content__title {
    color: #222;
}

.content table th {
    border-bottom: 2px solid #222;
    font-size: 12px;
}

.va-data-table__vuetable th.sortable {
    color: #222;
}

.imgdata {
    cursor: pointer;
    margin-left: 2px;
    margin-right: 2px;
}

.button-create-dea{
    background-color: rgb(255, 255, 255);
    border-color: rgb(34, 34, 34);
    border-radius: 4.8px;
    border-style: solid;
    font-size: 20px;
    height: 47px;
    width: 120px;
    cursor: pointer;

}
.button-create-dea:hover{
    background-color: #d0ab4b;
    color: white;
}

.images_container{
    display: flex;
    flex-direction: row;
}
</style>
